import type {
  AttendanceDashboardElasticSource,
  AttendanceDashboardQueryParams,
} from '@src/models/interfaces/attendanceDashboard.interface';
import type { ElasticSearchResponse } from '@src/models/interfaces/general/ElasticSearchResponseInterface';
import { apiCallable } from '@src/util/cloud-functions/apiClient';
import { API_OPERATIONS } from '@src/util/cloud-functions/operations';
import safeExecute from '@src/util/safeExecute';

class AttendanceDashboardRepository {
  query(
    params: AttendanceDashboardQueryParams,
  ): Promise<ElasticSearchResponse<AttendanceDashboardElasticSource> | null> {
    return safeExecute(async () => {
      const queryFn = apiCallable<
        AttendanceDashboardQueryParams,
        ElasticSearchResponse<AttendanceDashboardElasticSource>
      >(API_OPERATIONS.ATTENDANCE_DASHBOARD_QUERY);
      const response = await queryFn(params);
      const responseData = response.data;

      if (!responseData?.hits) {
        return null;
      }

      return responseData;
    });
  }
}

export default AttendanceDashboardRepository;
